module.exports = __webpack_public_path__ + "static/img/something-went-wrong.db51f95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/something-went-wrong.svg
// module id = CPFC
// module chunks = 0